/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Open_Cli_ToolInputs */

const en_open_cli_tool = /** @type {(inputs: Open_Cli_ToolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open ${i?.name}`)
};

const fr_open_cli_tool = /** @type {(inputs: Open_Cli_ToolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ouvrir ${i?.name}`)
};

const de_open_cli_tool = /** @type {(inputs: Open_Cli_ToolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Öffnen Sie ${i?.name}`)
};

const it_open_cli_tool = /** @type {(inputs: Open_Cli_ToolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aperto ${i?.name}`)
};

const ru_open_cli_tool = /** @type {(inputs: Open_Cli_ToolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Открыть ${i?.name}`)
};

const es_open_cli_tool = /** @type {(inputs: Open_Cli_ToolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abierto ${i?.name}`)
};

const zh_cn2_open_cli_tool = /** @type {(inputs: Open_Cli_ToolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`打开${i?.name}`)
};

const ja_open_cli_tool = /** @type {(inputs: Open_Cli_ToolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を開く`)
};

const hi_open_cli_tool = /** @type {(inputs: Open_Cli_ToolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} खोलें`)
};

const pt_pt2_open_cli_tool = /** @type {(inputs: Open_Cli_ToolInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abrir ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Open {name}" |
*
* @param {Open_Cli_ToolInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const open_cli_tool = /** @type {((inputs: Open_Cli_ToolInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Open_Cli_ToolInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_open_cli_tool(inputs)
	if (locale === "de") return de_open_cli_tool(inputs)
	if (locale === "it") return it_open_cli_tool(inputs)
	if (locale === "ru") return ru_open_cli_tool(inputs)
	if (locale === "es") return es_open_cli_tool(inputs)
	if (locale === "zh-CN") return zh_cn2_open_cli_tool(inputs)
	if (locale === "ja") return ja_open_cli_tool(inputs)
	if (locale === "hi") return hi_open_cli_tool(inputs)
	if (locale === "pt-PT") return pt_pt2_open_cli_tool(inputs)
	return en_open_cli_tool(inputs)
});